module.exports = __webpack_public_path__ + "img/chrome11.ca0180d1.png";